'use client';

import {useEffect, useRef} from 'react';

import {Container} from '@/modules/foundation/components/container';
import type {ExtractContentBlockType} from '@/modules/foundation/sanity/content-blocks/ContentBlocks';

type Props = ExtractContentBlockType<'cookieDeclaration'>;

export const CookieDeclaration = (props: Props) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = process.env.NEXT_PUBLIC_COOKIE_SCRIPT_REPORT ?? '';
			script.setAttribute('data-cookiescriptreport', 'report');
			containerRef.current.appendChild(script);
		}
	}, []);

	if (!props) {
		return null;
	}

	const {contentBlockOptions} = props;

	return (
		<Container
			spacingBottom={contentBlockOptions?.spacingBottom}
			spacingTop={contentBlockOptions?.spacingTop}
			width="text"
		>
			<div>
				{process.env.NODE_ENV !== 'development' && (
					<div
						ref={containerRef}
						className="[&_h4]:font-display [&_h4]:mt-8 [&_h4]:mb-4 [&_h4]:scroll-m-14 [&_h4]:text-xl [&_h4]:font-semibold md:[&_h4]:text-2xl [&_table]:block [&_table]:overflow-x-auto"
					/>
				)}
			</div>
		</Container>
	);
};
